module.exports = __webpack_public_path__ + "img/wx.55a00349.png";